export enum roles {
  WORKSPACE_ADMIN = "Workspace Admin",
  RESEARCHER = "Researcher",
  ANNOTATOR = "Annotator",
}
